var _g, _path, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_428_36076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4332 7.3076H11.1501V6.46239C11.1501 6.23823 11.0611 6.02325 10.9025 5.86474C10.744 5.70624 10.5291 5.61719 10.3049 5.61719H6.92406C6.6999 5.61719 6.48492 5.70624 6.32641 5.86474C6.1679 6.02325 6.07885 6.23823 6.07885 6.46239V7.3076H5.79148C5.75562 7.3076 5.72122 7.32185 5.69586 7.34721C5.6705 7.37257 5.65625 7.40697 5.65625 7.44284V8.44018C5.65625 8.51498 5.71668 8.57541 5.79148 8.57541H6.07885V11.111C6.07885 11.3435 6.07885 11.5336 6.50146 11.5336V12.1675C6.50146 12.2236 6.52372 12.2773 6.56335 12.317C6.60297 12.3566 6.65672 12.3788 6.71276 12.3788H7.55797C7.61401 12.3788 7.66775 12.3566 7.70738 12.317C7.74701 12.2773 7.76927 12.2236 7.76927 12.1675V11.5336H9.45969V12.1675C9.45969 12.2236 9.48195 12.2773 9.52157 12.317C9.5612 12.3566 9.61495 12.3788 9.67099 12.3788H10.5162C10.5722 12.3788 10.626 12.3566 10.6656 12.317C10.7052 12.2773 10.7275 12.2236 10.7275 12.1675V11.5336C11.1501 11.5336 11.1501 11.3435 11.1501 11.111V8.57541H11.4332C11.4702 8.57541 11.5057 8.56072 11.5319 8.53457C11.558 8.50841 11.5727 8.47294 11.5727 8.43595C11.5727 8.39897 11.558 8.3635 11.5319 8.33734C11.5057 8.31119 11.4702 8.29649 11.4332 8.29649C11.3963 8.29649 11.3608 8.31119 11.3346 8.33734C11.3085 8.3635 11.2938 8.39897 11.2938 8.43595C11.2938 8.47294 11.3085 8.50841 11.3346 8.53457C11.3608 8.56072 11.3963 8.57541 11.4332 8.57541C11.4702 8.57541 11.5057 8.56072 11.5319 8.53457C11.558 8.50841 11.5727 8.47294 11.5727 8.43595V7.44706C11.5727 7.41007 11.558 7.3746 11.5319 7.34845C11.5057 7.3223 11.4702 7.3076 11.4332 7.3076ZM7.76927 6.03979H9.45969V6.46239H7.76927V6.03979ZM6.92406 10.6884C6.81198 10.6884 6.70449 10.6439 6.62524 10.5647C6.54598 10.4854 6.50146 10.3779 6.50146 10.2658C6.50146 10.1537 6.54598 10.0463 6.62524 9.967C6.70449 9.88775 6.81198 9.84322 6.92406 9.84322C7.03614 9.84322 7.14363 9.88775 7.22289 9.967C7.30214 10.0463 7.34667 10.1537 7.34667 10.2658C7.34667 10.3779 7.30214 10.4854 7.22289 10.5647C7.14363 10.6439 7.03614 10.6884 6.92406 10.6884ZM6.50146 8.99802V6.885H10.7275V8.99802H6.50146ZM10.3049 10.6884C10.1928 10.6884 10.0853 10.6439 10.0061 10.5647C9.92681 10.4854 9.88229 10.3779 9.88229 10.2658C9.88229 10.1537 9.92681 10.0463 10.0061 9.967C10.0853 9.88775 10.1928 9.84322 10.3049 9.84322C10.417 9.84322 10.5245 9.88775 10.6037 9.967C10.683 10.0463 10.7275 10.1537 10.7275 10.2658C10.7275 10.3779 10.683 10.4854 10.6037 10.5647C10.5245 10.6439 10.417 10.6884 10.3049 10.6884Z",
    fill: "#421F00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60079 8.3552L1.49836 8.41317L0.110339 5.42077L11.7969 0L14.698 6.25438L5.6938 10.4309L4.75595 8.40905L3.60079 8.3552Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23313 11.5108C2.56985 10.0808 2.50178 8.4459 3.0439 6.96574C3.58603 5.48558 4.69394 4.28141 6.12391 3.61812C7.55388 2.95483 9.18878 2.88676 10.6689 3.42889C12.1491 3.97101 13.3533 5.07892 14.0166 6.50889",
    stroke: "#421F00",
    strokeWidth: 0.95096
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22583 8.39991L2.75164 10.9854L4.22787 8.37128L1.22583 8.39991Z",
    fill: "#421F00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_36076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 16,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6414 9.6448L15.7438 9.58683L17.1318 12.5792L5.44531 18L2.54423 11.7456L11.5484 7.56906L12.4862 9.59095L13.6414 9.6448Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_36076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0091 6.48924C14.6723 7.91921 14.7404 9.5541 14.1983 11.0343C13.6562 12.5144 12.5482 13.7186 11.1183 14.3819C9.6883 15.0452 8.05341 15.1132 6.57325 14.5711C5.09309 14.029 3.88892 12.9211 3.22563 11.4911",
    stroke: "#421F00",
    strokeWidth: 0.95096
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0085 9.60009L14.4827 7.01457L13.0065 9.62872L16.0085 9.60009Z",
    fill: "#421F00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_428_36076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.76166,
    height: 6.76166,
    fill: "white",
    transform: "translate(5.23438 5.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdle);
export default __webpack_public_path__ + "static/media/idle.2539a845397a96755164eca341c64456.svg";
export { ForwardRef as ReactComponent };